import { buildProps, definePropType } from '@sgui-plus/utils/props'
import type { StyleValue } from 'vue'

export const statisticProps = buildProps({
  /**
   * 数字标题
   */
  title: String,
  /**
   * 数字的前缀
   */
  prefix: String,
  /**
   * 数字的后缀
   */
  suffix: String,
  /**
   * 起始数字
   */
  startValue: {
    type: Number,
    default: 0
  },
  /**
   * 数字
   */
  value: {
    type: Number,
    default: 0
  },
  /**
   * 动画持续时间
   */
  duration: {
    type: Number,
    default: 3000
  },
  /**
   * 是否自动开始动画效果
   */
  autoplay: {
    type: Boolean,
    default: true
  },
  /**
   * 数字精度
   */
  precision: {
    type: Number,
    default: 0,
    validator(value) {
      return value >= 0
    }
  },
  /**
   * 小数点符号
   */
  decimal: {
    type: String,
    default: '.'
  },
  /**
   * 千分位标识符
   */
  separator: {
    type: String,
    default: ','
  },
  /**
   * 数字样式
   */
  valueStyle: {
    type: definePropType<StyleValue>([String, Object, Array]),
  }
})

export const statisticEmits = {
  onFinish: () => true
}
